export default __webpack_public_path__ + "static/8c359c6f761169111719a7782e4bd736.webp";